import React from 'react';
import './FacebookPagePlugin.css';

const FacebookPagePlugin: React.FC = () => {
  return null; // Component removed - Stay Connected section is no longer displayed
};

export default FacebookPagePlugin;
